// src/axiosConfig.js
import axios from 'axios';

// Create an instance of axios
const axiosInstance = axios.create({
    baseURL: 'https://iyk-back-end.onrender.com', // Base URL of your backend https://next-event-backend-f441b2925a36.herokuapp.com
    timeout: 10000000, // Timeout after 10 seconds
    headers: {
        'Content-Type': 'application/json', // Default content type
    },
    maxContentLength: 50 * 1024 * 1024, // 50 MB max content length
    maxBodyLength: 50 * 1024 * 1024, // 50 MB max request body length

});

// You can add interceptors to handle requests and responses globally
axiosInstance.interceptors.request.use(
    config => {
        // You can modify the request config before sending it
        // For example, add authorization tokens here
        // config.headers.Authorization = `Bearer ${token}`;
        return config;
    },
    error => {
        // Handle request error
        return Promise.reject(error);
    }
);

axiosInstance.interceptors.response.use(
    response => {
        // Any status code that lie within the range of 2xx cause this function to trigger
        return response;
    },
    error => {
        // Any status codes that falls outside the range of 2xx cause this function to trigger
        // Handle response error
        return Promise.reject(error);
    }
);

export default axiosInstance;
//https://sherehe-yetu-backend.onrender.com
// 'http://10.29.202.27:3000'